import { sortAsc, sortDesc } from './sort.js';

const max = (...specificities) => {
    const sorted = sortDesc(...specificities);
    return sorted[0];
};

const min = (...specificities) => {
    const sorted = sortAsc(...specificities);
    return sorted[0];
};

export { max, min };
